export const userDetailSegmentReducer = (state, action) => {
	switch (action.type) {
		case "SET_USER_DIRECT_TUNNEL_STATUS":
			return { ...state, userDirectTunnelStatus: action.payload }
		case "SET_COPY_BUTTON_COLOR":
			return { ...state, copyButtonColor: "grey" }
		default:
			return state
	}
}
